import type { SelectionSlotsProps } from './types'

// The selection tiles are part of the native App MVP design only.
const SelectionSlots = (_props: SelectionSlotsProps) => null

export default SelectionSlots
